/**
 * Utility function to check if an insurance certificate is currently valid.
 * A certificate is valid if the current date is between validatedAt and expiresAt.
 *
 * @param insuranceCertificate - The insurance certificate object with validatedAt and expiresAt dates
 * @returns true if the certificate is valid, false otherwise
 */
export function isInsuranceCertificateValid(
  insuranceCertificate?: {
    validatedAt?: string | null
    expiresAt?: string | null
  } | null
): boolean {
  if (!insuranceCertificate) {
    return false
  }

  const { validatedAt, expiresAt } = insuranceCertificate

  if (!validatedAt || !expiresAt) {
    return false
  }

  try {
    const now = new Date()
    const validatedDate = new Date(validatedAt)
    const expiresDate = new Date(expiresAt)

    // Check if dates are valid
    if (isNaN(validatedDate.getTime()) || isNaN(expiresDate.getTime())) {
      return false
    }

    // Check if now is between validatedAt and expiresAt (inclusive)
    return now >= validatedDate && now <= expiresDate
  } catch {
    // If date parsing fails, consider the certificate invalid
    return false
  }
}
